import React from 'react';
import { Container, Row } from 'shards-react';
import PageTitle from '../../../components/common/PageTitle';
import { useTranslation } from 'react-i18next';
import Nord from '../../../components/contract-item/nord';
import Sud from '../../../components/contract-item/sud';
import Ouest from '../../../components/contract-item/ouest';
import Est from '../../../components/contract-item/est';
const ListContract = (props) => {
  const { displayOptions } = props;
  const { t } = useTranslation();
  return (
    <Container fluid className="main-content-container px-4 pb-4">
      <Row noGutters className="page-header py-4">
        <PageTitle sm="4" title={t('contract.title.list')} subtitle={t('contract.subTitle')} className="text-sm-left" />
      </Row>

      <div className="flex-xxl-nowrap">
        <Nord displayOptions={displayOptions} />
        <Ouest displayOptions={displayOptions} />
        <Est displayOptions={displayOptions} />
        <Sud displayOptions={displayOptions} />
      </div>
    </Container>
  );
};

export default ListContract;
